import {MethodRequests} from "../../../constants/requests";
import {ContentParams, fetchRelatedContentBody, ID_Param, ID_Params, ILogin, IProfile, ValidateTokenParams} from "./user.interfaces";
import Keys from "../../../constants/helper";
import {routes} from "../../../routes/routes";

export const userServices = {
    authSignUp: (body: ILogin) => ({
        url: "/token/",
        method: MethodRequests.POST,
        body
    }),
    getValidateToken: (params?: ValidateTokenParams) => {
        const queryParams = new URLSearchParams();
        if (params?.content) queryParams.append("content", String(params.content));
        if (params?.client_ip) queryParams.append("client_ip", params.client_ip);
        const queryString = queryParams.toString();

        return {
            url: `/token/validate/${queryString ? `?${queryString}` : ""}`
        };
    },
    getAvatars: () => ({
        url: "/accounts/avatars/"
    }),
    getProfiles: () => ({
        url: "/accounts/profiles/"
    }),
    getProfilesById: (id: ID_Params) => ({
        url: `/accounts/profiles/${id}/`
    }),
    getList: (id: ID_Params) => ({
        url: `/accounts/mylist/${id}/`
    }),
    addToList: (id: ID_Param, body: ContentParams) => ({
        url: `/accounts/mylist/${id.profileID}/`,
        method: MethodRequests.PUT,
        body
    }),
    deleteToList: (id: ID_Param, body: Pick<ContentParams, "content">)=>({
        url: `/accounts/mylist/${id.profileID}/`,
        method: MethodRequests.DELETE,
        body
    }),
    getWatchingList: (id: ID_Params) => ({
        url: `/accounts/watching/${id}/`
    }),
    continueWatchingList: (id: ID_Param, body: ContentParams) => ({
        url: `/accounts/watching/${id.profileID}/`,
        method: MethodRequests.PUT,
        body
    }),
    deleteWatchingItem: (id: ID_Param, body: Pick<ContentParams, "content" | "client_ip">) => ({
        url: `/accounts/watching/${id.profileID}/`,
        method: MethodRequests.DELETE,
        body
    }),
    updateProfile: (id: ID_Params, body: IProfile) => ({
        url: `/accounts/profiles/${id}/`,
        method: MethodRequests.PUT,
        body
    }),
    createProfile: (body: IProfile) => ({
        url: "/accounts/profiles/",
        method: MethodRequests.POST,
        body
    }),
    deleteProfile: (id: ID_Params) => ({
        url: `/accounts/profiles/${id}/`,
        method: MethodRequests.DELETE
    }),
    fetchRelatedContent: (id: ID_Param, body: fetchRelatedContentBody) => ({
        url: `/accounts/clients/${id.profileID}/adult_verification/`,
        method: MethodRequests.POST,
        body
    }),
}

export const forceLogout = (reason?: string) => {
    const keysToRemove = [
        Keys.EPIC_JWT,
        Keys.EPIC_REFRESH_TOKEN,
        Keys.EPIC_USER_DATA,
        Keys.EPIC_PROFILE_ID,
        Keys.EPIC_USER_ROLE,
        Keys.EPIC_SUBSCRIPTION_EXPIRATION
    ];
    keysToRemove.forEach(key => localStorage.removeItem(key));
    document.cookie.split(";").forEach(cookie => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
    if (reason) {
        sessionStorage.setItem(Keys.EPIC_LOGOUT_REASON, reason);
    } else {
        sessionStorage.removeItem(Keys.EPIC_LOGOUT_REASON);
    }
    window.location.replace(routes.login);
};
